export const STOREFRONT_LINK_TEXT = 'Discover their story';
export const VISIT_SHOP_CTA = 'Visit shop';
export const CONTACT_PARTNER_CTA = 'Contact brand';
